export enum ConversableType {
  Room = 'Room',
  ActionPlanTask = 'ActionPlanTask',
}

export enum ConversationOwnerType {
  Contact = 'Contact',
  User = 'User',
}

export enum ConversationMentionType {
  Contact = 'Contact',
  User = 'User',
}
